define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/Controller",
	"csi/middleware/customView/customViewValidateService",
	"csi/util",
], function(declare, _, Controller, {writeMigrationKeyReportOperations}, util) {

	return declare(Controller, {
		/**
		 * @override
		 * Ensure that all results are loaded on page
		 */
		onPreActionDeferreds(dfds) {
			dfds.push(this.widget.queryMoreToTarget(true));
		},

		/**
		 * @override
		 * Output XML script of all errors
		 */
		process() {
			const {m_writer, widget} = this;

			_.each(_.keys(widget._mapKeyReports).sort(), (targetClass) => {
				const report = widget._mapKeyReports[targetClass];
				writeMigrationKeyReportOperations(m_writer, targetClass, report);
			});

			const win = open("", "Canvas Migration");
			if (win) {
				win.document.write("<HTML><HEAD><TITLE>Canvas Migration</TITLE></HEAD>");
				win.document.write("<BODY><pre>" + util.xmlToString(util.serializeXML(m_writer.doc)) + "</pre></BODY></HTML>");
				win.document.close();
			}

			widget.resetMigration();
			this.postProcess();
		}
	});
});